<contest-payment-confirm [contestId]="contestId"
                         [userId]="userId"
                         [role]="role"
                         [groupId]="groupId"></contest-payment-confirm>
